import { Chip } from '@festo-ui/react';

import { useAppSelector } from '../../app/hooks';
import useTranslation from '../../features/translation/hooks/useTranslation';
import './ChipsContainer.scss';

const ChipsContainer = () => {
  const t = useTranslation();
  const { filtersStructure, filtersValue } = useAppSelector((state) => state.filter);

  return (
    <div className="fwe-chip-container fwe-chip-container-lg fwe-chip-container fwe-mb-5">
      {filtersStructure.map((filter) =>
        filter.filters ? (
          filter.filters.map((subFilter) => (
            <div className="chip-unit" key={subFilter.id}>
              <span className="label">{t(subFilter.label)}</span>
              <Chip selected>
                {filtersValue[subFilter.key]} {t(subFilter.unit ?? '')}
              </Chip>
            </div>
          ))
        ) : (
          <div className="chip-unit" key={filter.id}>
            <span className="label">{t(filter.label)}</span>
            <Chip selected>
              {filtersValue[filter.key]} {t(filter.unit ?? '')}
            </Chip>
          </div>
        ),
      )}
    </div>
  );
};

export default ChipsContainer;
